// page services 
import { TimelineMax } from 'gsap';
$(document).ready(function () {
    var isBreakPoint = function (bp) {
        var bps = [320, 480, 768, 992, 1199],
            w = $(window).width(),
            min, max
        for (var i = 0, l = bps.length; i < l; i++) {
            if (bps[i] === bp) {
                min = bps[i - 1] || 0
                max = bps[i]
                break
            }
        }
        return w > min && w <= max
    }
    
    $(".services_list").owlCarousel({
        items: 7,
        margin: 15,
        loop: false,
        dots: false,
        center: true,
        nav: false,
        mouseDrag : true,
        responsive: {
            // breakpoint from 0 up
            0: {
                items: 1,
                center: true,
                dots: true
            },
            // breakpoint from 480 up
            480: {
                items: 2,
                dots: true,
                center: true,
            },
            // breakpoint from 768 up
            768: {
                items: 3,
                dots: true,
                nav: true,
                center: false,
            },
            992: {
                items: 4,
                dots: true,
                nav: true,
                center: false,
            },
            1400: {
                items: 5,
                dots: true,
                nav: true,
                center: false,
            },
            2200: {
                items: 7,
                dots: false,
                nav: true,
                center: false,
            }

        }
    });

    // if ($('.page-template-services').length) {

        

    //     $(".services_list").on("dragged.owl.carousel", function (event) {
    //         if (isBreakPoint(320) || isBreakPoint(480) || isBreakPoint(768)) {
            
    //             if (event.relatedTarget['_drag']['direction'] == "left") {
    //                 $('.services_list--item.active').removeClass('active').parent().parent().next().find('a').trigger('click');
    //             } else {
    //                 $('.services_list--item.active').removeClass('active').parent().parent().prev().find('a').trigger('click');
    //             }
    //         }
    //     });
        


    //     var hash = window.location.hash.substr(1);

    //     var tlServiceContent = new TimelineMax();

    //     function changeService(service) {

    //         $('.services_list--item').removeClass('active');
    //         $('.service_description--wrapper').removeClass('active');
    //         var currentService = service.data('service');
    //         service.addClass('active');
    //         $('.service_description--wrapper[data-service="' + currentService + '"]').addClass('active');
    //         // tlServiceContent.pause();
    //         tlServiceContent
    //             .from(".service_description--wrapper.active h2", 0.5, { y: "50", ease: "back.out(0.8)", autoAlpha: 0 })
    //             .from(".service_description--wrapper.active .service_description--text", 0.5, { y: "50", ease: "back.out(0.8)", autoAlpha: 0 }, "-=0.4")
    //             .from(".service_description--wrapper.active .service_description--image", 0.5, { y: "500", ease: "back.out(0.8)", autoAlpha: 0 }, "-=0.4")

    //         window.location.hash = '#' + currentService;


    //     }




    //     tlServiceContent
    //         .from(".service_description--wrapper.active h2", 0.5, { y: "50", ease: "back.out(0.8)", autoAlpha: 0 })
    //         .from(".service_description--wrapper.active .service_description--text", 0.5, { y: "50", ease: "back.out(0.8)", autoAlpha: 0 }, "-=0.4")
    //         .from(".service_description--wrapper.active .service_description--image", 0.5, { y: "500", ease: "back.out(0.8)", autoAlpha: 0 }, "-=0.4")
        
     
    //         $('.services_list--item:not(.active)').on('click', function (e) {
    //             if($(this).hasClass('haslink')){
    //                 return true;
    //             }else{
    //                 e.preventDefault();
    //             }
                
    //             if(!$(this).hasClass('active')){
    //                 changeService($(this));
    //             }
                
    //         });
            
       
    //     if (hash) {
    //         $('.services_list--item[data-service="' + hash + '"]').trigger('click');
    //         var position = hash.replace(/[^0-9]/gi, '');
    //         var numberposition = parseInt(position, 10);
    //         var numberposition = numberposition-1;

    //         // $(".services_list").trigger("to.owl.carousel", numberposition, 300);

    //     } else {

    //         $('.services_list--item[data-service="service-1"]').trigger('click');
    //     }

    // }

   
});